import { Moment } from 'moment'

//その月の第X曜日を取ること
export function getNthDayOfWeek(input: Moment): number {
  return Math.ceil(input.date() / 7)
}
